var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHideUtgl = function SvgHideUtgl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.597 2.408 15.995 15.995.812-.811-4.543-4.543a4 4 0 0 0-4.91-4.91L6.852 6.042A6.737 6.737 0 0 1 16.737 12H18A8 8 0 0 0 5.926 5.114L2.408 1.597l-.811.811Zm3.735 4.735-.894-.893A7.977 7.977 0 0 0 2 12h1.263c0-1.908.794-3.631 2.069-4.857Zm7.589 7.59L7.267 9.079a4 4 0 1 0 5.654 5.654Z",
    fill: "#DC9B32"
  })));
};
export default SvgHideUtgl;